const base64Encrypt = (text: string) => {
	return btoa(text);
};

export default base64Encrypt;
